import axios from 'axios';
import { API_URL } from '../../config/api';
import { UserSession } from './model';
export type Pending = { kind: 'delete'; item: UserSession } | { kind: 'bulk'; items: UserSession[] };
export async function performAction(pending: Pending): Promise<{ message: string; failed?: UserSession[] }> {
  if (pending.kind === 'delete') { await axios.delete(`${API_URL}/admin/sessions/${pending.item.id}`); return { message: 'Oturum kaydı silindi.' }; }
  const failed: UserSession[] = []; let deleted = 0, missing = 0;
  for (let index = 0; index < pending.items.length; index++) {
    const item = pending.items[index];
    if (item.is_active) { failed.push(item); continue; }
    try { await axios.delete(`${API_URL}/admin/sessions/${item.id}`); deleted++; }
    catch (error) { if (axios.isAxiosError(error) && error.response?.status === 404) { missing++; continue; } failed.push(item); if (axios.isAxiosError(error) && [401, 403, 429].includes(error.response?.status || 0)) { failed.push(...pending.items.slice(index + 1)); break; } }
  }
  return { message: `${deleted} pasif oturum kaydı silindi.${missing ? ` ${missing} kayıt zaten kaldırılmış.` : ''}`, failed };
}
